<dx-validation-group #validationGroup>
    @if(details){
        <div class="card border-0 shadow-sm pt-0 pb-1 mb-4">
            <div class="card-header fs-5 fw-medium">Emergency Details</div>
            <div class="card-body">
                <div class="card-title mb-3 fs-7 text-uppercase">Emergency Details</div>
                <div class="px-3 row g-3 mb-4">
                    <div class="col-md-4">
                        <label class="form-label">Emergency Contact Name</label>
                        <dx-text-box
                            [(value)]="details.emergencyContactName"
                            stylingMode="filled"
                            valueChangeEvent="input"
                            (onValueChanged)="onFieldChange()"
                            [readOnly]="isReadOnly"
                        ></dx-text-box>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Emergency Contact Number</label>
                        <dx-text-box
                            [(value)]="details.emergencyContactNumber"
                            stylingMode="filled"
                            valueChangeEvent="input"
                            mask="(000) 000-0000"
                            (onValueChanged)="onFieldChange()"
                            [readOnly]="isReadOnly"
                        ></dx-text-box>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Medical Conditions</label>
                        <dx-text-box
                            [(value)]="details.medicalConditions"
                            stylingMode="filled"
                            valueChangeEvent="input"
                            placeholder="List all that may apply"
                            (onValueChanged)="onFieldChange()"
                            [readOnly]="isReadOnly"
                        ></dx-text-box>
                    </div>
                </div>
            </div>
        </div>
    }
</dx-validation-group>

